import { render, staticRenderFns } from "./PlanNewSignature.vue?vue&type=template&id=73224127&scoped=true&"
import script from "./PlanNewSignature.vue?vue&type=script&lang=js&"
export * from "./PlanNewSignature.vue?vue&type=script&lang=js&"
import style0 from "./PlanNewSignature.vue?vue&type=style&index=0&id=73224127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73224127",
  null
  
)

export default component.exports